import React from "react";
import { RequestStateIcons } from "./RequestStateIcons";

export const VoucherButton = ({
  status,
  formName,
}: {
  status: "idle" | "loading" | "success" | "error";
  formName: string;
}) => {
  return (
    <button
      disabled={status === "loading"}
      type="submit"
      form={formName}
      className="disabled:gg-bg-gray-200 gg-transition-colors gg-ease-in-out gg-duration-300 hover:gg-cursor-pointer gg-border-none hover:gg-bg-yellow-400 gg-bg-yellow-300 gg-flex gg-flex-row gg-items-center gg-gap-3.5 gg-font-bold gg-text-slate-800 gg-whitespace-nowrap gg-rounded-sm  gg-text-lg gg-px-5 sm:gg-px-6 gg-py-2.5"
    >
      Gebruiken
      <span className="gg-w-5">
        <RequestStateIcons status={status} />
      </span>
    </button>
  );
};
